__turbopack_context__.v({
  "brand": "ReplusShowtimeLink-module-scss-module__tK3Bdq__brand",
  "label": "ReplusShowtimeLink-module-scss-module__tK3Bdq__label",
  "text": "ReplusShowtimeLink-module-scss-module__tK3Bdq__text",
});
